// src/components/pages/correlation/components/HeatmapModal.js

import React from 'react';
import Plot from 'react-plotly.js';
import DOMPurify from 'dompurify';
import styles from '../style/CorrPage.module.css'; // 경로 수정 필요

function HeatmapModal({ stocks, correlationMatrix, show, onClose, t }) {
  if (!show || correlationMatrix.length === 0) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <button className={styles.modalCloseButton} onClick={onClose}>
          &times;
        </button>
        <div className={styles.heatmapChartWrapper}>
          <div className={styles.heatmapChartInner}>
            <Plot
              data={[
                {
                  z: correlationMatrix,
                  x: stocks.map(stock => DOMPurify.sanitize(stock, { USE_PROFILES: { html: false }})), 
                  y: stocks.map(stock => DOMPurify.sanitize(stock, { USE_PROFILES: { html: false }})), 
                  type: "heatmap",
                  colorscale: [
                    [0, "rgb(49,54,149)"],
                    [0.5, "rgb(255,255,191)"],
                    [1, "rgb(165,0,38)"],
                  ],
                  reversescale: false,
                  hoverongaps: false,
                  zmin: -1,
                  zmax: 1,
                },
              ]}
              layout={{
                title: t("correlation.heatmapTitle"),
                autosize: true,
                margin: { l: 100, r: 100, t: 50, b: 100 },
                xaxis: { 
                  tickfont: { size: 14, family: "Arial, sans-serif" },
                  fixedrange: true
                },
                yaxis: { 
                  tickfont: { size: 14, family: "Arial, sans-serif" },
                  fixedrange: true
                },
                height: '100%',
              }}
              config={{ 
                displayModeBar: false, 
                scrollZoom: false,
                dragmode: false, 
                displaylogo: false,
              }}
              useResizeHandler={true}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
        <p className={styles.heatmapExplanation}>
          {t("correlation.heatmap.explanation")}
        </p>
      </div>
    </div>
  );
}

export default HeatmapModal;